jQuery( document ).ready( function( ) {
	/**
	 * Load More For resource Template Start
	 */
	let page = 2; // Start from page 2 since the first 9 posts are already loaded
	let total_pages = 0;
	if ( jQuery( '.load-more' ).length > 0 ) {
		const buttonData = jQuery( '.load-more' );
		const pages = parseInt( buttonData.data( 'total-pages' ) );
		const slug = buttonData.data( 'slug' );

		total_pages = pages + 1;
	}

	jQuery( '.load-more' ).on( 'click', function( e ) {
		e.preventDefault();
		const button = jQuery( this ),
			container = jQuery( '.three-columns' ),
			loader = jQuery( '<div class="loader">Loading...</div>' );
		const slug = jQuery( this ).data( 'slug' );

		// Add loader animation
		button.html( loader );
		jQuery.ajax( {
			url: localVars.ajax_url, // AJAX handler URL (defined by WordPress)
			type: 'POST',
			data: {
				action: 'load_more_posts',
				page,
				slug,
				tag,
			},
			success( response ) {
				if ( response ) {
					container.append( response );
					page++;
					button.html( 'Load More' );
				}
				if ( page === total_pages ) {
					button.remove(); // No more posts to load, remove the button
				}
			},
		} );
	} );
	/**
	 * Load More For resource Template End
	 */
	/**
	 * Load More For news Template Start
	 */

	/**
	 * Load More For news Template End
	 */
	/**
	 * Load More For Survey Template Start
	 */

	let surveyPage = 2; // Start from page 2 since the first 9 posts are already loaded
	let surveyTotalPages = 0;
	if ( jQuery( '.load-more-survey ' ).length > 0 ) {
		const suveyButtonData = jQuery( '.load-more-survey ' );
		const surveyPages = parseInt( suveyButtonData.data( 'total-pages' ) );
		surveyTotalPages = surveyPages + 1;
	}

	jQuery( '.load-more-survey' ).on( 'click', function( e ) {
		e.preventDefault();
		const surveyButton = jQuery( this ),
			surveyContainer = jQuery( '#survey-container' ),
			loader = jQuery( '<div class="loader">Loading...</div>' );

		// Add loader animation
		surveyButton.html( loader );
		jQuery.ajax( {
			// eslint-disable-next-line no-undef
			url: localVars.ajax_url, // AJAX handler URL (defined by WordPress)
			type: 'POST',
			data: {
				action: 'load_more_survey',
				surveyPage,
			},
			success( response ) {
				if ( response ) {
					surveyContainer.append( response );
					surveyPage++;
					surveyButton.html( 'Load More' );
				}
				if ( surveyPage === surveyTotalPages ) {
					surveyButton.remove(); // No more posts to load, remove the button
				}
			},
		} );
	} );

	/**
	 * Load More For Survey Template End
	 */
	/**
	 * Load More For Taxonomy Archive Template Start
	 */
	let archivePage = 2; // Start from page 2 since the first 9 posts are already loaded
	let slug;
	let tag;
	let archiveTotalPages = 0;
	if ( jQuery( '.load-more-archive ' ).length > 0 ) {
		const archiveBtnData = jQuery( '.load-more-archive ' );
		const archivePages = parseInt( archiveBtnData.data( 'total-pages' ) );
		slug = archiveBtnData.data( 'slug' );
		tag = archiveBtnData.data( 'tag' );
		archiveTotalPages = archivePages + 1;
	}

	jQuery( '.load-more-archive' ).on( 'click', function( e ) {
		e.preventDefault();
		const surveyButton = jQuery( this ),
			archiveContainer = jQuery( '.three-columns' ),
			loader = jQuery( '<div class="loader">Loading...</div>' );

		// Add loader animation
		surveyButton.html( loader );
		jQuery.ajax( {
			// eslint-disable-next-line no-undef
			url: localVars.ajax_url, // AJAX handler URL (defined by WordPress)
			type: 'POST',
			data: {
				action: 'load_more_archive',
				archivePage,
				slug,
				tag,
			},
			success( response ) {
				if ( response ) {
					archiveContainer.append( response );
					archivePage++;
					surveyButton.html( 'Load More' );
				}
				if ( archivePage === archiveTotalPages ) {
					surveyButton.remove(); // No more posts to load, remove the button
				}
			},
		} );
	} );
} );
/**
 * Load More For Taxonomy Archive Template End
 */
